import { Controller } from "@hotwired/stimulus"
import CSVBoxImporter from "@csvbox/csvboxjs"

export default class extends Controller {
  static values = {
    apiKey: String,
    callbackToken: String
  }

  initialize() {
    this.importer = new CSVBoxImporter(this.apiKeyValue, {}, (_result, data) => {
      const remoteIdInput = document.querySelector("#list_upload__id")
      const rowCountInput = document.querySelector("#list_upload_upload_row_count")
      const form = document.querySelector(".edit_list_upload")

      if (!remoteIdInput || !rowCountInput || !form) return

      remoteIdInput.value = data.import_id
      rowCountInput.value = data.row_success
      form.submit()
    })
  }

  start_upload() {
    const listIdInput = document.querySelector("#list_upload_id")
    const userId = document.body.getAttribute("data-userid")

    if (!listIdInput || !userId) return

    this.importer.setUser({
      user_id: userId,
      list_upload_id: listIdInput.value,
      list_upload_token: this.callbackTokenValue
    })

    this.importer.openModal()
  }
}
